import { render, staticRenderFns } from "./RbAppMenu.vue?vue&type=template&id=0b36461c&"
import script from "./RbAppMenu.vue?vue&type=script&lang=js&"
export * from "./RbAppMenu.vue?vue&type=script&lang=js&"
import style0 from "./RbAppMenu.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports